<template>
  <div id="app">
    <section>
      <button
          v-if="!$store.state.administrationUser.selectedUserDetail.employmentEndDate" class="btn-basic btn-fill-pulse-dark mr-2"
          style="width: 180px;"
          @click="showModal()" :disabled="isChangingActiveState">
        Samenwerking stopzetten
      </button>
      <button
          v-else class="btn-basic btn-fill-pulse mr-2"
          style="width: 180px;"
          @click="activateUser()" :disabled="isChangingActiveState">
        Samenwerking verderzetten
      </button>
    </section>
    <modal id="inline-modal" v-cloak>
      <template slot="title">Laatste werkdag</template>
      <div slot="body">
                      <DateInputField class="w-50 d-inline-block" v-model="$store.state.administrationUser.selectedUserTerminationDate" labelText="Einddatum"/>
      </div>
      <div slot="footer">
        <button class="btn-basic btn-outline-pulse-dark mr-2" @click="closeModal()">Annuleren</button>
        <button class="btn-basic btn-outline-pulse mr-2" @click="() => terminateEmployment()">Opslaan</button>
      </div>
    </modal>
  </div>
</template>
<script>
import { Modal, VoerroModal } from '@voerro/vue-modal';
import Vue from 'vue';
import {mapActions} from "vuex";
import DateInputField from "@/components/inputFields/DateInputField.vue";
Vue.component('modal', Modal);
window.VoerroModal = VoerroModal;
VoerroModal.show('inline-modal');
export default {
  name: 'TerminateUserModal',
  components: {
    DateInputField,
  },
  data() {
    return {
      isChangingActiveState: false,
      isModalVisible: true,
    };
  },
  methods: {
    ...mapActions("administrationUser", [
      "updateProlongedSickLeaveForSelectedUser",
      "terminateUserWithEndDate",
      "activateUser"
    ]),
    showModal() {
      VoerroModal.show('inline-modal');
    },
    closeModal() {
      VoerroModal.hide('inline-modal');
    },
    terminateEmployment() {
      const promise = this.terminateUserWithEndDate(this.$store.state.administrationUser.selectedUserTerminationDate);

      promise.then(() => {
        VoerroModal.hide('inline-modal');
      });


    },
  },

};
</script>